import { type ReactElement, useMemo } from "react";
import styles from "./Loader.module.scss";

interface LoaderProps {
  /** Whether to display as full block (centered) or inline */
  fullBlock?: boolean;
  /** Optional text to display below the spinner */
  text?: string;
}

export function Loader({ fullBlock = false, text }: LoaderProps): ReactElement {
  const containerClass = useMemo(() => {
    return fullBlock
      ? `${styles.loaderContainer} ${styles.fullBlock}`
      : `${styles.loaderContainer} ${styles.inline}`;
  }, [fullBlock]);

  return (
    <div className={containerClass}>
      <div className={styles.loaderSpinner} />
      {text && <div className={styles.loaderText}>{text}</div>}
    </div>
  );
}
